import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StepContainerComponent} from './step-container/step-container.component';
import {AttachmentsCardComponent} from './attachments-card/attachments-card.component';
import {SubsidyWizardContainerComponent} from './subsidy-wizard-container/subsidy-wizard-container.component';
import {StepperComponent} from './stepper/stepper.component';
import {ProductSelectItemComponent} from './product-select-item/product-select-item.component';
import {CoreModule} from '../core/core.module';
import {OnlineStatusComponent} from './online-status/online-status.component';
import {SubsidyTypeSelectorComponent} from './subsidy-type-selector/subsidy-type-selector.component';
import {ProjectLocationFormComponent} from './project-location-form/project-location-form.component';
import {PirteComponent} from './pirte/pirte.component';
import {DeminimisStepComponent} from './deminimis-step/deminimis-step.component';
import {ProjectPhasesTableComponent} from './project-phases-table/project-phases-table.component';
import {SignStepComponent} from './sign-step/sign-step.component';
import {FinancialTableComponent} from './financial-table/financial-table.component';
import {ManualStepComponent} from './manual-step/manual-step.component';
import {ReportContainerComponent} from './report-container/report-container.component';
import {BeneficiaryFormComponent} from './beneficiary-form/beneficiary-form.component';

const components = [
	StepContainerComponent,
	AttachmentsCardComponent,
	SubsidyWizardContainerComponent,
	StepperComponent,
	ProductSelectItemComponent,
	OnlineStatusComponent,
	SubsidyTypeSelectorComponent,
	ProjectLocationFormComponent,
	PirteComponent,
	ProjectPhasesTableComponent,
	SignStepComponent,
	DeminimisStepComponent,
	FinancialTableComponent,
	ManualStepComponent,
	ReportContainerComponent,
	BeneficiaryFormComponent,
];

@NgModule({
	declarations: [...components],
	imports: [CommonModule, CoreModule],
	exports: [...components],
})
export class ComponentsModule {}
